<script setup lang="ts">
import {useCookieBanner, } from "@/store/overlays/cookie-banner";
import { useI18n } from 'vue-i18n'
import {onMounted} from "vue";

const cookie_banner = useCookieBanner();
const { t } = useI18n();

onMounted(() => {
  if (localStorage.getItem('cookie-banner-accepted') === "true") {
    cookie_banner.hide();
  }
});
</script>

<template>
  <v-container v-if="cookie_banner.is_visible" class="cookie-banner border-t-md">
    <v-card width="100%" variant="flat" >
      <v-card-title class="text-wrap">
        {{t('title')}} <v-icon icon="mdi-lock"/>
      </v-card-title>
      <v-card-text class="pb-2">
        {{t('cookie')}}
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pt-0">
        <v-btn @click="cookie_banner.hide()" variant="flat" color="primary" size="large">
          {{t('close')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<i18n lang="yaml">
en:
  title: 'We value your privacy'
  cookie: 'We only use our strictly necessary in-house cookies and Stripe ones to secure your payments.'
  close: 'Accept'
it:
  title: 'Abbiamo a cuore la tua privacy'
  cookie: 'Usiamo solamente cookie interni strettamente necessari e quelli di Stripe per proteggere i vostri pagamenti'
  close: 'Accetta'
de:
  title: 'Wir schätzen Ihre Privatsphäre'
  cookie: 'Wir verwenden nur unsere unbedingt notwendigen internen Cookies und die von Stripe, um Ihre Zahlungen zu sichern.'
  close: 'Akzeptieren'
fr:
  title: "Nous accordons de l'importance à votre privacy"
  cookie: "Nous n'utilisons que les cookies internes strictement nécessaires et ceux de Stripe pour sécuriser vos paiements."
  close: 'Accepter'
nl:
  title: 'Wij hechten waarde aan uw privacy'
  cookie: 'We gebruiken alleen onze strikt noodzakelijke interne cookies en die van Stripe om uw betalingen te beveiligen.'
  close: 'Accepteer'
es:
  title: 'Valoramos su privacidad'
  cookie: 'Solo utilizamos nuestras cookies internas estrictamente necesarias y las de Stripe para proteger sus pagos.'
  close: 'Aceptar'
</i18n>

<style scoped lang="scss">
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  color: white;
  text-align: center;
  padding: 5px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
